import React from "react";
import { Card, CardBody, CardTitle, CardText, Container } from "reactstrap";
import "./MenuItem.css";

export const MenuItem = ({ item, onClick }) => {
  // Calculate the discounted price
  const discountedPrice = item.discountDetail
    ? item.price - (item.price * item.discountDetail.discountPercentage) / 100
    : item.price;

  return (
    <div className="col-12 col-sm-6 col-lg-4 mb-4 right ribbon-box">
      <Card
        className="h-100 shadow-sm p-2 position-relative  "
        onClick={() => onClick(item)}
      >
        {/* Discount Ribbon */}
        {item.discountDetail && (
          <div className="ribbon-two ribbon-two-primary">
            <span className="text-white">
              {item.discountDetail.discountPercentage}% OFF
            </span>
          </div>
        )}

        <Container className="image-container p-0">
          <img
            src={item?.displayImage?.getCDNUrl() || "/api/placeholder/400/300"}
            alt={item.title}
            className=""
          />
        </Container>
        <CardBody>
          <CardTitle tag="h5" className="mb-2 text-capitalize">
            {item.title}
          </CardTitle>
          <CardText className="text-muted small">{item.description}</CardText>
          <div className="d-flex justify-content-between align-items-center mt-3">
            {/* Original Price with Strikethrough */}
            {/* {item.discountDetail ? (
              <div>
                <span className="text-muted text-decoration-line-through me-2">
                  NRS {item.price}
                </span>
                <span className="fw-bold text-danger">
                  NRS {discountedPrice.toFixed(2)}
                </span>
              </div>
            ) : (
              <span className="fw-bold">NRS {item.price}</span>
            )} */}
            {item.price !== 0 &&
              (item.discountDetail ? (
                <div>
                  <span className="text-muted text-decoration-line-through me-2">
                    NRS {item.price}
                  </span>
                  <span className="fw-bold text-danger">
                    NRS {discountedPrice.toFixed(2)}
                  </span>
                </div>
              ) : (
                <span className="fw-bold">NRS {item.price}</span>
              ))}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};
